import Layout from 'common/Layout';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';

const PrivateRouter = () => {
  const token = useSelector((state) => state.user.token) || localStorage.getItem('token');
  const isLoggedIn = Boolean(token);
  return (
    <div>
      {isLoggedIn ? (
        <Layout>
          <Outlet />
        </Layout>
      ) : (
        
        <Navigate to={'/signin'} replace/>
      )}
    </div>
  );
};
export default PrivateRouter;
